/**
 * Copyright (c) 2023 Google LLC
 * SPDX-License-Identifier: MIT
 */

export const PIE_SLICE_ZOOM = 1.03
